import { deliveringTabs } from "../routeHelper"

export const templates = {
  id: "delivering",
  config: "/delivering",
  build: () => "/delivering",
  children: [
    {
      id: "deliveringAddSchedule",
      config: "/delivering/add-schedule",
      build: () => `/delivering/add-schedule`,
    },
    {
      id: "deliveringOverview",
      config: "/delivering/:currentTab?",
      build: (currentTab) => {
        if (deliveringTabs.indexOf(currentTab) === -1) currentTab = ""

        return `/delivering/${currentTab}`
      },
    },
    {
      id: "deliveringScheduleItem",
      config: "/delivering/schedule/:id/:currentTab(overview|candidates|invigilators)?",
      build: (id, currentTab = "overview") => `/delivering/schedule/${id}/${currentTab}`,
      children: [
        {
          id: "deliveringAddInvigilators",
          config: "/delivering/schedule/:id/addInvigilators",
          build: (id) => `/delivering/schedule/${id}/addInvigilators`,
        },
      ],
    },
    {
      id: "deliveringInvigilationItem",
      config: "/delivering/invigilation/:id/items",
      build: (id) => `/delivering/invigilation/${id}/items`,
      children: [
        {
          id: "deliveringUserDetails",
          config: "/delivering/invigilation/:id/items/:uid",
          build: (id, uid) => `/delivering/invigilation/${id}/items/${uid}`,
        },
      ],
    },
    {
      id: "deliveringAddSchedule",
      config: "/delivering/add-schedule",
      build: () => `/delivering/add-schedule`,
      children: [
        {
          id: "deliveringAssessmentPreview",
          config: "/delivering/add-schedule/assessments/:id/preview",
          build: (id) => `/delivering/assessments/${id}/preview`,
        },
      ],
    },
    {
      id: "deliveringCandidateReview",
      config: "/delivering/candidate-review",
      build: () => `/delivering/candidate-review`,
    },
    {
      id: "deliveringCandidateReviewItem",
      config: "/delivering/candidate-review/:parentId",
      build: (parentId) => `/delivering/candidate-review/${parentId}`,
    },
  ],
}
